export const initSideCart = () => {
  const form1 = $('#VariationForm_Form');
  $(document).on('submit', '#VariationForm_Form', {form:form1}, changeSideCart);
  const form2 = $('#AddProductForm_Form');
  $(document).on('submit', '#AddProductForm_Form', {form:form2}, changeSideCart);
  $(document).on('click', hideSideCart);

  $(document).on('click','.product-card__tool--add-to-cart',addToCart);
}

function addToCart(event){
  event.preventDefault();
  $.ajax({
    url: $(this).attr('href'),
    success: function( response ) {
      $('[name="action_addtocart"]').addClass('button--is-added');
      $('.side-cart').replaceWith(response);
      $('.side-cart').addClass('side-cart--visible');
      setTimeout(() => {
        $('[name="action_addtocart"]').removeClass('button--is-added');
    }, 1500);
      if($('#CartForm_CartForm').length>0){
        // reload needed
        location.reload();
      }
}
});
}

function hideSideCart(event) {
  if (!$(event.target).closest('.side-cart').length) {
    $('.side-cart').removeClass('side-cart--visible');
  }
}

function changeSideCart(event) {
  event.preventDefault();
  $.ajax({
    url: event.data.form.attr('action'),
    type: event.data.form.attr('method'),
    data: event.data.form.serialize(),
    success: function( response ) {
      $('[name="action_addtocart"]').addClass('button--is-added');
      $('.side-cart').replaceWith(response);
      $('.side-cart').addClass('side-cart--visible');
      setTimeout(() => {
        $('[name="action_addtocart"]').removeClass('button--is-added');
      }, 1500);
    },
    error: function (response){
      console.log('error');
    }
  });
}